'use strict';

var isString = function isString(string) {
    return Object.prototype.toString.call(string) === "[object String]";
};
module.exports = {
    /**
     * 打印log日志<br />
     * 使用场景：调试时，使用alert会阻断进程，可以使用log进行调试<br />
     * 对应native接口：debug.log
     * @method hysdk.log
     * @category Log
     * @example
     * hysdk.log( "message" );
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    log: {
        hy: {
            key: 'debug.log',
            optHandle: function optHandle(msg) {
                if (isString(msg)) {
                    var param = {
                        message: msg
                    };
                    return param;
                }
                return msg;
            }
        }
    },
    /**
     * 向后端发送数据<br />
     * 对应native接口：hy.uelog
     * @method hysdk.uelog
     * @skip
     * @category Log
     * @example ./uelog.js[1-11]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    uelog: {
        hy: {
            key: 'hy.uelog'
        }
    },
    /**
     * 获取abTest的策略信息<br />
     * 对应native接口：abTest.getCase
     * @method hysdk.abTest
     * @skip
     * @category Log
     * @example ./abTest.js[1-12]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    abTest: {
        hy: {
            //TODO 验证是否是abTest.getCase
            key: 'abTest'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/log.js
// module id = 17
// module chunks = 0 2 4